import type { IconSvgObject } from './types';

const Music02Icon: IconSvgObject = [
  ["circle", { cx: "17.9922", cy: "15.75", r: "3", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "5.99219", cy: "17.75", r: "3", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M8.99219 17.75V9.66559M8.99219 9.66559V8.77944C8.99219 7.26371 8.99219 6.50585 9.41578 5.9576C9.83937 5.40936 10.5669 5.22555 12.022 4.85793L16.022 3.84738C18.3099 3.26938 19.4538 2.98038 20.223 3.58727C20.859 4.08907 20.9691 4.99061 20.9882 6.63495M8.99219 9.66559L20.9882 6.63495M20.9922 15.7289V7.76889C20.9922 7.35623 20.9922 6.9793 20.9882 6.63495M20.9882 6.63495L20.9922 6.63394", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default Music02Icon;
